import { render, staticRenderFns } from "./valida-email.vue?vue&type=template&id=7bfb8a12&scoped=true"
import script from "./valida-email.vue?vue&type=script&lang=js"
export * from "./valida-email.vue?vue&type=script&lang=js"
import style0 from "./valida-email.vue?vue&type=style&index=0&id=7bfb8a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb8a12",
  null
  
)

export default component.exports